// Lib
import React from 'react';

// Components
import Button from '../../Button';

// Styles
import { useStyles } from './FooterButtonsStyles';

const FooterButtons = ({
  withPrevButton = true,
  rejectTitle,
  onReject,
  onAccept = () => {},
  acceptTitle,
  isLoading,
  acceptBtnType,
  isAcceptBtnMain = true,
  className,
  disabledAcceptBtn = false,
}) => {
  const { classes, cx } = useStyles({ isAcceptBtnMain });

  return (
    <div className={cx(classes.buttons, className)}>
      {withPrevButton && (
        <Button
          id="reject-button"
          variant={isAcceptBtnMain ? 'text' : 'contained'}
          onClick={onReject}>
          {rejectTitle}
        </Button>
      )}
      <Button
        variant={!isAcceptBtnMain ? 'text' : 'contained'}
        id="accept-button"
        loadingIndicator="Loading…"
        onClick={onAccept}
        loading={isLoading}
        type={acceptBtnType}
        disabled={disabledAcceptBtn}>
        {acceptTitle}
      </Button>
    </div>
  );
};

export default FooterButtons;
